function closedKey(conversationId: string): string {
  return `memoair-live-panel-closed:${conversationId}`;
}

// Session storage can throw (private mode, blocked storage); auto-open then just stays on.
export function markLivePanelClosed(conversationId: string): void {
  try {
    sessionStorage.setItem(closedKey(conversationId), "1");
  } catch {
    // Not remembering the close only means the panel may auto-open again.
  }
}

export function wasLivePanelClosed(conversationId: string): boolean {
  try {
    return sessionStorage.getItem(closedKey(conversationId)) === "1";
  } catch {
    return false;
  }
}
